/* Бейдж проверки цены. Живёт отдельной строкой под содержимым карточки:
   в строку с ценой и временем он не встаёт даже на широком экране. */
.badge {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  width: 100%;
  /* Без min-width флекс-элемент не ужимается ниже своего содержимого, и
     многоточие в узкой карточке никогда не появится. */
  min-width: 0;
  padding: 1px var(--sp-2);
  background: var(--surface-2);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  color: var(--text-3);
  font: inherit;
  font-size: var(--fs-xs);
  line-height: 1.6;
  text-align: left;
  cursor: pointer;
}

.badge:hover {
  border-color: var(--border-strong);
}

/* Цвет несёт ровно один смысл: нашли дешевле / нашли дороже / та же цена.
   --warn здесь по назначению — это предупреждение «цена выше вашей». */
.badge.cheaper {
  color: var(--ok);
  border-color: color-mix(in srgb, var(--ok) 40%, var(--border));
  background: color-mix(in srgb, var(--ok) 8%, var(--surface-2));
  box-shadow: var(--glow-ok);
}

.badge.dearer {
  color: var(--warn);
  border-color: var(--warn-border);
  background: var(--warn-bg);
  box-shadow: var(--glow-warn);
}

.badge.same,
.badge.none {
  color: var(--text-3);
}

/* Проверка старше трёх суток (staleness.ts): показываем, но приглушённо —
   это уже не факт о сегодняшней цене. Текст при этом не прячем. */
.badge.stale {
  opacity: 0.72;
}

.icon {
  display: flex;
  flex: 0 0 auto;
}

/* Главная строка ужимается первой: сайт и цена важнее, чем целиком видимая
   фраза, а хвост уходит в многоточие. */
.text {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.percent {
  flex: 0 0 auto;
  font-size: var(--fs-xs);
  font-weight: 600;
}

.when {
  flex: 0 0 auto;
  color: var(--text-3);
  font-variant-numeric: tabular-nums;
}

/* ── Мобильный вид (порог продублирован в ui/shell/useIsMobile.ts) ──────── */
@media (max-width: 720px) {
  /* В узкой карточке «проверено 16.08» уезжает под фразу целой строкой:
     обрезать многоточием и её значило бы потерять сразу оба смысла. */
  .badge {
    flex-wrap: wrap;
    row-gap: 0;
  }

  .when {
    width: 100%;
  }
}
